import { frontEndConstants } from "../constant/front-end-constant";

const initialState = {
    testimonails: {
        data: []
    },
    loading:false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case frontEndConstants.GET_ALL_TESTIMONIALS_REQUEST:
            return { ...state, loading:true }
        case frontEndConstants.GET_ALL_TESTIMONIALS_SUCCESS:
            return {
                
                ...state,
                testimonails: action.payload.data.pagination, 
                pages: action.payload.data.pagination.last_page, 
                current_page: action.payload.data.pagination.current_page, 
                perPage: action.payload.data.pagination.per_page,
                loading: false
            }
        case frontEndConstants.GET_ALL_TESTIMONIALS_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        case frontEndConstants.STORE_TESTIMONAIL_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/testimonialReducer.jsx